import React, { useEffect, useRef, useState } from 'react';
import {
  Box, Button,
  Grid,
} from '@mui/material';
import { useLocation } from 'react-router-dom';
import { HasDiscountTableDownloadPermissionApi, PreviewSpecialsApi } from '@/services/api/specialPriceTable';
import TablePaginationActions from '@/components/priceDialog/TablePaginationActions';
import { PageOrderRequest } from '@/services/api/PageOrderRequest';
import Notice from '@/components/notice';
import { NoticeRef } from '@/components/notice/types';
import { PreviewSpecialsDto } from '@/services/api/specialPriceTable/message/PreviewSpecialsRequest';
import Pdf from './pdf';
import { BaseSize } from '@/styles';
import { generatePdf } from '@/components/pdfTool/pdfA4Script';

const PreviewSpecialsPdf = () => {
  const currentLocation = useLocation();

  const noticeRef = useRef<NoticeRef>(null);

  const [page, setPage] = useState<PageOrderRequest>({ Limit: 2, Page: 0 });

  const [total, setTotal] = useState(0);

  const [pdfList, setPdfList] = useState<Array<PreviewSpecialsDto>>([]);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    HasDiscountTableDownloadPermissionApi({}).then(data => {
      if (data === undefined || data?.Data === false || data?.Data === undefined) {
        setLoading(true);
      } else if (data?.Data === true) {
        setLoading(false);
      }
    });
    PreviewSpecialsApi({
      SpecialPrickCustomerInformationIdList: currentLocation.state as string[],
      Page: page,
    })
      .then(data => {
        if (data?.Data === undefined || data.Data.length === 0) {
          noticeRef.current?.Show({
            Message: data?.Msg,
            Open: true,
            TypeInfo: 'error',
          });
        }
        setPdfList(data.Data);
        setTotal(data.Total);
      });
  }, []);

  const generatePdfOnClick = async () => {
    await generatePdf('.previewSpecialsPdfPage', () => {
      setLoading(true);
    });
  };

  return (
        <Box>
            <Notice ref={noticeRef}/>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Button variant="contained" size={BaseSize.size} disabled={loading} onClick={() => {
                      generatePdfOnClick();
                    }}>
                        下载PDF
                    </Button>
                </Grid>
                <Grid item xs={12}>
                    &nbsp;
                </Grid>
            </Grid>
            <Grid container spacing={2} sx={{ overflowY: 'auto', overflowX: 'auto', height: '700px' }}>

                {
                    pdfList.map((row, index) => {
                      return (
                            <Grid item xs={6} key={'pdfDev' + index}>
                                <Pdf ClassName={'previewSpecialsPdfPage'} PriceDto={row}
                                     PdfPaperId={'pdfDiv2' + index}/>
                            </Grid>
                      );
                    })
                }

            </Grid>
        </Box>
  );
};

export default PreviewSpecialsPdf;
